import React from 'react';
import { motion } from 'framer-motion';

// Images Import
import PrimaryImg from '../assets/primary.png'; 
import SecondaryImg from '../assets/secondary.png'; 
import ALImg from '../assets/al.jpg'; 
import ProfessionalImg from '../assets/professional.png'; 

// onCategoryClick කියන prop එක මෙතනට එකතු කළා
const CategorySection = ({ onCategoryClick }) => {
  
  const categories = [
    {
      title: "Primary", // App.js එකේ logic එකට ගැලපෙන්න කෙටි කළා
      displayTitle: "Primary Education",
      subtitle: "Grades 1 to 5",
      description: "Foundational learning in core subjects with creative guidance.",
      image: PrimaryImg,
    },
    {
      title: "O/L", // මෙය Secondary School ලෙස තිබූ එක O/L ලෙස වෙනස් කළා filter එකට ගැලපෙන්න
      displayTitle: "Secondary School",
      subtitle: "Grades 6 to 11 (O/L)",
      description: "Comprehensive preparation for O/L exams across all major streams.",
      image: SecondaryImg,
    },
    {
      title: "A/L", // මෙය Advanced Level ලෙස තිබූ එක A/L ලෙස වෙනස් කළා
      displayTitle: "Advanced Level",
      subtitle: "Grades 12 to 13 (A/L)",
      description: "Expert coaching for A/L Science, Commerce, Arts, and Tech streams.",
      image: ALImg,
    },
    {
      title: "Professional",
      displayTitle: "Professional Courses",
      subtitle: "Skill Development",
      description: "IT, language proficiency, and soft skills training for career growth.",
      image: ProfessionalImg,
    }
  ];

  return (
    <section id="courses" className="py-16 md:py-24 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-20">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-indigo-600 font-bold tracking-widest uppercase text-xs md:text-sm"
          >
            Our Programs
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="mt-3 text-3xl md:text-5xl font-black text-indigo-950"
          >
            Choose Your Learning Path
          </motion.p>
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="mt-4 text-base md:text-xl text-gray-500 max-w-2xl mx-auto"
          >
            We provide a wide range of educational programs tailored to help every student succeed.
          </motion.div>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-10">
          {categories.map((cat, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              // --- CLICK EVENT එක මෙතනට එකතු කළා ---
              onClick={() => onCategoryClick(cat.title)} 
              className="group relative h-[400px] md:h-96 rounded-3xl overflow-hidden shadow-xl cursor-pointer"
            >
              {/* Image Background */}
              <div 
                className="absolute inset-0 transition-transform duration-700 group-hover:scale-110"
                style={{
                  backgroundImage: `url(${cat.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              />

              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-indigo-950 via-indigo-950/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" />

              {/* Content Area */}
              <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end text-white z-10">
                <h4 className="text-[10px] md:text-xs font-bold uppercase text-yellow-400 tracking-[0.2em] mb-2">
                    {cat.subtitle}
                </h4>
                <h3 className="text-2xl md:text-3xl font-black mb-3 leading-tight group-hover:text-yellow-50 transition-colors">
                    {cat.displayTitle}
                </h3>
                
                <p className="text-gray-200 text-sm leading-relaxed max-h-24 md:max-h-0 md:group-hover:max-h-24 transition-all duration-500 overflow-hidden opacity-100 md:opacity-0 md:group-hover:opacity-100">
                  {cat.description}
                </p>

                <div className="mt-6 flex items-center font-bold text-sm text-yellow-400 group-hover:text-white transition-colors">
                  Explore Classes 
                  <svg className="w-4 h-4 ml-2 group-hover:translate-x-2 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;